export default {
  get: {
    method: 'get',
    url: '/client/statistics/template?key=KEY'
  },
  create: {
    method: 'post',
    url: '/client/statistics/template'
  },
  delete: {
    method: 'delete',
    url: '/client/statistics/template/ID'
  },
  updateTemplate: {
    method: 'put',
    url: '/client/statistics/template/ID'
  },
  getStatistic: {
    method: 'get',
    url: '/client/statistics/CLASS'
  },
  getAllStatistic: {
    method: 'get',
    url: '/client/statistics/template/all'
  },
  chooseStatisticTemplate: {
    method: 'get',
    url: '/client/statistics/template/choose/ID'
  },
  deleteChooseStatisticTemplate: {
    method: 'get',
    url: '/client/statistics/template/choose/delete'
  }
}
